var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { MediaSummary } from '../../commons/medias/media';
/**
 * Affected endpoints
 * GET /manfredite/work-experiences
 * POST /manfredite/work-experiences/<id>
 * PUT /manfredite/work-experiences/<id>
 */
export class WorkExperienceResponse {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], WorkExperienceResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], WorkExperienceResponse.prototype, "jobRole", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], WorkExperienceResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], WorkExperienceResponse.prototype, "dateFrom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], WorkExperienceResponse.prototype, "dateTo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], WorkExperienceResponse.prototype, "technologies", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], WorkExperienceResponse.prototype, "organization", void 0);
__decorate([
    Expose(),
    Type(() => MediaSummary),
    __metadata("design:type", MediaSummary)
], WorkExperienceResponse.prototype, "logo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], WorkExperienceResponse.prototype, "url", void 0);
//# sourceMappingURL=work-experience.response.js.map